import { Directive, ElementRef, Input, OnChanges, Renderer2, SimpleChanges } from '@angular/core';
import { human } from '../tools/human-currency';

@Directive({
  selector: '[human]'
})
export class HumanDirective implements OnChanges {
  @Input('human') amount: number | null | undefined;
  @Input() humanDisplayCents = false;
  @Input() humanShowDirection = true;
  @Input() humanNoSymbol = false;

  constructor(
    private elementRef: ElementRef<HTMLElement>,
    private renderer: Renderer2
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    this.render();
  }

  private render() {
    console.log("hit");
    const amount = this.amount || 0;
    const direction = this.getDirection(amount);
    const label = this.humanShowDirection && direction ? ` ${direction}` : '';

    this.renderer.setProperty(
      this.elementRef.nativeElement,
      'textContent',
      `${human(amount, this.humanDisplayCents, this.humanNoSymbol)}${label}`
    );

    this.setDirectionClasses(direction);
  }

  private getDirection(amount: number) {
    if (amount > 0) {
      return 'Credit';
    }

    if (amount < 0) {
      return 'Debit';
    }

    return '';
  }

  private setDirectionClasses(direction: string) {
    this.renderer.addClass(this.elementRef.nativeElement, 'human-currency');

    this.renderer.removeClass(this.elementRef.nativeElement, 'human-credit');
    this.renderer.removeClass(this.elementRef.nativeElement, 'human-debit');
    this.renderer.removeClass(this.elementRef.nativeElement, 'human-zero');

    if (direction === 'Credit') {
      this.renderer.addClass(this.elementRef.nativeElement, 'human-credit');
      return;
    }

    if (direction === 'Debit') {
      this.renderer.addClass(this.elementRef.nativeElement, 'human-debit');
      return;
    }

    this.renderer.addClass(this.elementRef.nativeElement, 'human-zero');
  }
}
